import { useEventBus } from '@hc-frontend/core-ui';
import { useEffect, useState } from 'react';

export function TypCountdown({ onEnd }: { onEnd: () => void }) {
  const eventBus = useEventBus();
  const [count, setCount] = useState(45);

  useEffect(() => {
    const interval = setInterval(() => {
      setCount((current) => {
        const newValue = current - 1;
        if (newValue < 0) {
          clearInterval(interval);
          onEnd();
        }

        return newValue;
      });
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [setCount, onEnd, eventBus]);

  return count;
}
